import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { getIntlLocale } from '../i18n'

export function useLocale() {
  const { i18n } = useTranslation()
  const locale = getIntlLocale(i18n.language)

  const toDate = useCallback((value: Date | string) => {
    return value instanceof Date ? value : new Date(value)
  }, [])

  const formatDate = useCallback(
    (value: Date | string, options?: Intl.DateTimeFormatOptions) => {
      return toDate(value).toLocaleDateString(locale, options)
    },
    [locale, toDate]
  )

  const formatTime = useCallback(
    (value: Date | string, options?: Intl.DateTimeFormatOptions) => {
      return toDate(value).toLocaleTimeString(locale, options)
    },
    [locale, toDate]
  )

  const formatDateTime = useCallback(
    (value: Date | string, options?: Intl.DateTimeFormatOptions) => {
      return toDate(value).toLocaleString(locale, options)
    },
    [locale, toDate]
  )

  const formatNumber = useCallback(
    (value: number, options?: Intl.NumberFormatOptions) => {
      return new Intl.NumberFormat(locale, options).format(value)
    },
    [locale]
  )

  return {
    locale,
    formatDate,
    formatTime,
    formatDateTime,
    formatNumber,
  }
}
